import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class BusApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/bus' + path, queryMap);
  }

  findBusSeats(
    status: string,
    username: string,
    bus_id: string,
    page: number,
    pageSize: number,
  ) {
    const url = this.buildurl('/seats', {
      status,
      username,
      bus_id,
      page,
      page_size: pageSize,
    });
    return this.http.fget(url);
  }

  checkUserBusSeat(busTypeID: number) {
    const url = this.buildurl('/bus/seat/check', { bus_type_id: busTypeID });
    return this.http.fget(url);
  }

  findBusSeatsByBus(id: number) {
    const url = this.buildurl(`/bus/${id}/seats`);
    return this.http.fget(url);
  }

  updateUserBusSeatAccount(id: number, username: string, password: string) {
    const url = this.buildurl(`/bus/seat/${id}/account`);
    const body = {
      username,
      password,
    };
    return this.http.put(url, body);
  }

  getBusSeat(bus_seat_id: any) {
    const url = this.buildurl('/seatsid', { bus_seat_id });
    return this.http.fget(url);
  }

  waitRepairTime(bus_seat_id: number, bus_id: number, bus_account_id: number) {
    const url = this.buildurl('/netflix/popcorn/todo');
    const body = {
      bus_seat_id,
      bus_id,
      bus_account_id,
    };
    return this.http.post(url, body);
  }

  changeAdobe(bus_seat_id: number) {
    const url = this.buildurl('/exchange/product');
    const body = {
      bus_seat_id,
    };
    return this.http.post(url, body);
  }

  changePopcorn(bus_seat_id: number, start_time: any, end_time: any) {
    const url = this.buildurl('/netflix/popcorn/exchange');
    const body = {
      bus_seat_id,
      start_time,
      end_time,
    };
    return this.http.post(url, body);
  }

  changeJiegehao(
    bus_seat_id: number,
    platform_id: number,
    bus_id: number,
    bus_account_id: number,
    remaining_days: number,
  ) {
    const url = this.buildurl('/jiegehao/todo');
    const body = {
      bus_seat_id,
      platform_id,
      bus_id,
      bus_account_id,
      remaining_days,
    };
    return this.http.post(url, body);
  }

  refundWallet(id: number) {
    const url = this.buildurl(`/refund/wallet/${id}`);
    return this.http.put(url, {});
  }

  refundWalletAdobe(bus_seat_id: number) {
    const body = { bus_seat_id };
    const url = this.buildurl('/refund/remaining');
    return this.http.post(url, body);
  }

  getRefundInfoAdobe(bus_seat_id: number) {
    const q = { bus_seat_id };
    const url = this.buildurl('/refund/preview', q);
    return this.http.get(url);
  }

  getRefundAmount(id: number) {
    const url = this.buildurl(`/refund/price/${id}`);
    return this.http.get(url);
  }

  freezeTime(bus_seat_id: number, name: string) {
    const url = this.buildurl('/exchange/popcorn');
    const body = {
      bus_seat_id,
      name,
    };
    return this.http.post(url, body);
  }

  changeYoutubeRecharge(id: number) {
    const url = this.buildurl(`/bus/seat/color/${id}`);
    return this.http.fget(url);
  }

  checkYoutubeRecharge() {
    const url = this.buildurl('/checkyoutube');
    return this.http.fget(url);
  }

  findAdobeTeam() {
    const url = this.buildurl('/adobe');
    return this.http.fget(url);
  }

  changeAccountError(
    id: number,
    username: string,
    password: string,
    backup_code_one: string,
    backup_code_two: string,
  ) {
    const body = { username, password, backup_code_one, backup_code_two };
    const url = this.buildurl(`/bus/seat/${id}/yt`);
    return this.http.put(url, body);
  }

  getAccountCode(cdk: string, pt_type: string) {
    const body = { cdk, pt_type };
    const url = this.buildurl('/yzmcode');
    return this.http.post(url, body);
  }
}
